import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    state = 0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.setState, {
        id,
        state,
    }, options);
    if (error) return { error, status };
    return content || {};
};

